// Global Upsell Popup - Initialize once and manage state properly
window.UpsellPopup = (function() {
  let instance = null;
  
  function UpsellPopupClass() {
    this.$modal = null;
    this.$slider = null;
    this.splide = null;
    this.upsellProducts = [];
    this.isLoading = false;
    this.isModalOpen = false;
    this.hasShownUpsell = false;
    this.isInitialized = false;
    this.debug = true;
  }
  
  UpsellPopupClass.prototype.init = function() {
    if (this.isInitialized) return;
    
    this.$modal = $('#upsell-modal');
    this.$slider = $('#upsell-slider');
    
    this.bindEvents();
    this.loadUpsellProducts();
    this.isInitialized = true;
    
    console.log('UpsellPopup initialized');
  };
  
  UpsellPopupClass.prototype.loadUpsellProducts = function() {
    const self = this;
    let cartItems = document.querySelectorAll(".my-cart__items[data-upsell-product]");
    let upsellHandles = [];
    
    // Collect unique product handles
    cartItems.forEach(item => {
      let handle = item.getAttribute('data-upsell-product');
      if (handle && !upsellHandles.includes(handle)) {
        upsellHandles.push(handle);
      }
    });
    
    console.log('Found upsell handles:', upsellHandles);
    
    if (upsellHandles.length === 0) {
      this.upsellProducts = [];
      return;
    }
    
    // Create promises for product data
    const productPromises = upsellHandles.map(handle => {
      return new Promise((resolve, reject) => {
        $.getJSON(`/products/${handle}.js`)
          .done(function(product) {
            resolve({
              id: product.id,
              handle: product.handle,
              title: product.title,
              featuredImage: product.featured_image || "/placeholder.svg?height=400&width=400",
              price: product.price,
              compareAtPrice: product.compare_at_price,
              available: product.available,
              variants: product.variants.map(variant => ({
                id: variant.id,
                title: variant.title,
                price: variant.price,
                compareAtPrice: variant.compare_at_price,
                available: variant.available
              }))
            });
          })
          .fail(function(jqXHR, textStatus, errorThrown) {
            console.error(`Error fetching product ${handle}:`, textStatus, errorThrown);
            resolve(null); // Resolve with null instead of rejecting
          });
      });
    });

    // Wait for all product data
    Promise.all(productPromises)
      .then(products => {
        // Get current cart state
        const cartState = window.liquidAjaxCart.getCartState();
        const cartProductIds = cartState.cart.items.map(item => item.product_id);

        // Filter out products already in cart and null products
        self.upsellProducts = products.filter(product => 
          product && product.id && !cartProductIds.includes(product.id)
        );

        console.log('Filtered upsell products:', self.upsellProducts);
      })
      .catch(error => {
        console.error('Error loading upsell products:', error);
        self.upsellProducts = [];
      });
  };
  
  UpsellPopupClass.prototype.bindEvents = function() {
    const self = this;
    
    // Remove any existing event listeners to prevent duplicates
    $(document).off('click.upsellPopup');
    $(document).off('keydown.upsellPopup');
    
    // Bind checkout button click
    $(document).on('click.upsellPopup', '.checkout-btn', function(e) {
      console.log("Checkout button clicked - checking for upsell");
      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Check if we should show upsell
      if (!self.hasShownUpsell && !self.isModalOpen && self.upsellProducts && self.upsellProducts.length > 0) {
        self.showUpsellModal();
      } else {
        self.proceedToCheckout();
      }
      
      return false;
    });

    // Modal close events
    $('#upsell-close').off('click').on('click', function() {
      self.closeModal();
    });

    $('#decline-upsell').off('click').on('click', function() {
      self.proceedToCheckout();
    });

    // Modal overlay click
    $('.upsell-modal-overlay').off('click').on('click', function() {
      self.closeModal();
      self.proceedToCheckout();
    });

    // Add to cart buttons (delegated)
    $(document).off('click.upsellProduct').on('click.upsellProduct', '.add-upsell-btn', function(e) {
      self.addUpsellToCart($(this));
    });

    // Variant selection
    $(document).off('change.upsellVariant').on('change.upsellVariant', '.variant-select', function(e) {
      self.updateVariantPrice($(this));
    });

    // Keyboard events
    $(document).on('keydown.upsellPopup', function(e) {
      if (self.isModalOpen && e.key === 'Escape') {
        self.closeModal();
      }
    });
  };
  
  UpsellPopupClass.prototype.showUpsellModal = function() {
    if (this.isLoading || this.isModalOpen) return;
    
    console.log("Showing upsell modal");
    this.isModalOpen = true;
    this.hasShownUpsell = true;
    
    this.$modal.css('display', 'flex');
    $('body').css('overflow', 'hidden');
    
    if (this.upsellProducts && this.upsellProducts.length > 0) {
      this.renderUpsellProducts();
    } else {
      // No upsell products, proceed to checkout
      const self = this;
      setTimeout(function() {
        self.proceedToCheckout();
      }, 500);
    }
  };
  
  UpsellPopupClass.prototype.closeModal = function() {
    console.log("Closing upsell modal");
    this.isModalOpen = false;
    
    this.$modal.css('display', 'none');
    $('body').css('overflow', '');
    
    // Destroy Splide instance if it exists
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  };
  
  UpsellPopupClass.prototype.renderUpsellProducts = function() {
    const template = $('#upsell-product-template').html();
    
    if (this.$slider.length && template && this.upsellProducts && this.upsellProducts.length > 0) {
      // Clear any existing content
      this.$slider.empty();
      
      // Add products to slider
      const self = this;
      $.each(this.upsellProducts, function(index, product) {
        if (!product || !product.id) return;
        
        const firstVariant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
        if (!firstVariant) return;
        
        const comparePrice = product.compareAtPrice && product.compareAtPrice > product.price ? 
          (product.compareAtPrice / 100).toFixed(2) : null;
        const price = (product.price / 100).toFixed(2);
        const discountPercentage = comparePrice ? 
          Math.round(((product.compareAtPrice - product.price) / product.compareAtPrice) * 100) : null;

        let comparePriceDisplay = comparePrice ? '' : 'display: none;';
        let discountDisplay = discountPercentage ? '' : 'display: none;';
        let variantSelectorDisplay = product.variants && product.variants.length > 1 ? '' : 'display: none;';

        let variantsOptions = '';
        if (product.variants && product.variants.length > 0) {
          $.each(product.variants, function(i, variant) {
            variantsOptions += `<option value="${variant.id}" data-price="${(variant.price / 100).toFixed(2)}" ${variant.available ? '' : 'disabled'}>
              ${variant.title} ${variant.available ? '' : '(Sold Out)'}
            </option>`;
          });
        }

        let productImage = product.featuredImage || '/placeholder.svg?height=200&width=200';

        let productHtml = template
          .replace(/PRODUCT_ID_PLACEHOLDER/g, product.id)
          .replace(/VARIANT_ID_PLACEHOLDER/g, firstVariant.id)
          .replace(/PRODUCT_IMAGE_PLACEHOLDER/g, productImage)
          .replace(/PRODUCT_TITLE_PLACEHOLDER/g, product.title || 'Product')
          .replace(/COMPARE_PRICE_PLACEHOLDER/g, comparePrice || '')
          .replace(/PRICE_PLACEHOLDER/g, price)
          .replace(/DISCOUNT_PERCENTAGE_PLACEHOLDER/g, discountPercentage || '')
          .replace(/COMPARE_PRICE_DISPLAY_PLACEHOLDER/g, comparePriceDisplay)
          .replace(/DISCOUNT_DISPLAY_PLACEHOLDER/g, discountDisplay)
          .replace(/VARIANT_SELECTOR_DISPLAY_PLACEHOLDER/g, variantSelectorDisplay)
          .replace(/VARIANTS_OPTIONS_PLACEHOLDER/g, variantsOptions);

        self.$slider.append(productHtml);
      });
      
      // Initialize Splide after products are added
      this.initSplide();
    }
  };
  
  UpsellPopupClass.prototype.initSplide = function() {
    // Destroy existing instance if it exists
    if (this.splide) {
      this.splide.destroy();
    }
    
    // Initialize new Splide instance
    if (typeof Splide !== 'undefined') {
      this.splide = new Splide('#upsell-splide', {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: 20,
        pagination: this.upsellProducts.length > 1,
        arrows: this.upsellProducts.length > 1,
        autoplay: false,
        rewind: true,
        breakpoints: {
          768: {
            perPage: 1,
            arrows: true,
            pagination: true
          }
        }
      }).mount();
    }
  };
  
  UpsellPopupClass.prototype.updateVariantPrice = function($selectElement) {
    const $selectedOption = $selectElement.find('option:selected');
    const price = $selectedOption.data('price');
    const $productElement = $selectElement.closest('.upsell-product');
    const $priceElement = $productElement.find('.sale-price');
    const $addButton = $productElement.find('.add-upsell-btn');
    
    if ($priceElement.length) $priceElement.text(`$${price}`);
    if ($addButton.length) {
      $addButton.attr('data-variant-id', $selectElement.val());
      $addButton.prop('disabled', $selectedOption.prop('disabled'));
    }
  };
  
  UpsellPopupClass.prototype.addUpsellToCart = function($button) {
    if ($button.prop('disabled')) return;
    
    const originalText = $button.text();
    $button.text('ADDING...').prop('disabled', true);

    const variantId = $button.attr('data-variant-id');
    const self = this;
    
    // Use liquid-ajax-cart
    window.liquidAjaxCart.cartRequestAdd({ 
      items: [
        {
          id: variantId,
          quantity: 1
        }
      ]  
    }, {
      lastComplete: function(requestState) {
        if (requestState.responseData && requestState.responseData.ok) {
          $button.text('ADDED!').css('background', '#28a745');
          setTimeout(function() {
            self.proceedToCheckout();
          }, 1000);
        } else {
          console.error('Error adding upsell to cart:', requestState);
          $button.text('ERROR - TRY AGAIN').css('background', '#dc3545');
          setTimeout(function() {
            $button.text(originalText).css('background', '#d4af37').prop('disabled', false);
          }, 2000);
        }
      }
    });
  };
  
  UpsellPopupClass.prototype.proceedToCheckout = function() {
    this.closeModal();
    setTimeout(function() {
      window.location.href = '/checkout';
    }, 100);
  };
  
  UpsellPopupClass.prototype.reset = function() {
    console.log('Resetting upsell popup state');
    this.hasShownUpsell = false;
    this.closeModal();
  };
  
  UpsellPopupClass.prototype.refresh = function() {
    console.log('Refreshing upsell products');
    this.loadUpsellProducts();
  };
  
  // Singleton pattern
  return {
    getInstance: function() {
      if (!instance) {
        instance = new UpsellPopupClass();
      }
      return instance;
    }
  };
})();

// Initialize when document is ready
$(document).ready(function() {
  const upsellPopup = window.UpsellPopup.getInstance();
  upsellPopup.init();
});